var j = Object.defineProperty, C = Object.defineProperties;
var G = Object.getOwnPropertyDescriptors;
var n = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, c = Object.prototype.propertyIsEnumerable;
var l = (t, r, e) => r in t ? j(t, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[r] = e, i = (t, r) => {
  for (var e in r || (r = {}))
    p.call(r, e) && l(t, e, r[e]);
  if (n)
    for (var e of n(r))
      c.call(r, e) && l(t, e, r[e]);
  return t;
}, d = (t, r) => C(t, G(r));
var f = (t, r) => {
  var e = {};
  for (var o in t)
    p.call(t, o) && r.indexOf(o) < 0 && (e[o] = t[o]);
  if (t != null && n)
    for (var o of n(t))
      r.indexOf(o) < 0 && c.call(t, o) && (e[o] = t[o]);
  return e;
};
import { jsx as H } from "react/jsx-runtime";
import "react";
import { g as L, a as V } from "./get-size-BzhHC8s2.js";
import { c as k } from "./create-vars-resolver-Bzbn9G-G.js";
import { b as q, B as w, f as A, h as D } from "./factory-BnRIVbT0.js";
import { u as E } from "./use-styles-CB9_o8RJ.js";
import { p as I } from "./polymorphic-factory-CU4yDpSd.js";
var u = { root: "m_b6d8b162" };
function J(t) {
  if (t === "start")
    return "start";
  if (t === "end" || t)
    return "end";
}
const K = {
  inherit: !1
}, M = k(
  (t, { variant: r, lineClamp: e, gradient: o, size: s, color: a }) => ({
    root: {
      "--text-fz": V(s),
      "--text-lh": L(s),
      "--text-gradient": r === "gradient" ? D(o, t) : void 0,
      "--text-line-clamp": typeof e == "number" ? e.toString() : void 0,
      "--text-color": a ? A(a, t) : void 0
    }
  })
), x = I((t, r) => {
  const e = q("Text", K, t), m = e, {
    lineClamp: o,
    truncate: s,
    inline: a,
    inherit: g,
    gradient: O,
    span: v,
    __staticSelector: y,
    vars: h,
    className: T,
    style: b,
    classNames: S,
    styles: N,
    unstyled: _,
    variant: z,
    mod: B,
    size: F
  } = m, P = f(m, [
    "lineClamp",
    "truncate",
    "inline",
    "inherit",
    "gradient",
    "span",
    "__staticSelector",
    "vars",
    "className",
    "style",
    "classNames",
    "styles",
    "unstyled",
    "variant",
    "mod",
    "size"
  ]), R = E({
    name: ["Text", y],
    props: e,
    classes: u,
    className: T,
    style: b,
    classNames: S,
    styles: N,
    unstyled: _,
    vars: h,
    varsResolver: M
  });
  return /* @__PURE__ */ H(
    w,
    i(d(i({}, R("root", { focusable: !0 })), {
      ref: r,
      component: v ? "span" : "p",
      variant: z,
      mod: [
        {
          "data-truncate": J(s),
          "data-line-clamp": typeof o == "number",
          "data-inline": a,
          "data-inherit": g
        },
        B
      ],
      size: F
    }), P)
  );
});
x.classes = u;
x.displayName = "@mantine/core/Text";
export {
  x as T
};
